import React from "react";
import { MdAdd } from "react-icons/md";

export const CreateTriggerBtn = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="px-4 py-2 bg-1 text-sm font-light flex items-center gap-3 rounded-xl"
    >
      <MdAdd />
      Create Workflow
    </button>
  );
};

export default CreateTriggerBtn;
